import { twMerge } from 'tailwind-merge';
import Button from '@/components/Button';
import { classes } from './utils';

export type MenuFooterProps = {
  onEdit: () => void;
  onDelete: () => void;
};

export default function MenuFooter({ onEdit, onDelete }: MenuFooterProps) {
  return (
    <div className={classes.wrapper}>
      <Button
        className={twMerge(classes.button, classes.deleteText)}
        variant="ghost"
        onClick={onDelete}>
        Delete
      </Button>
      <Button
        className={twMerge(classes.button, classes.editText)}
        variant="ghost"
        onClick={onEdit}>
        Edit
      </Button>
    </div>
  );
}
